export default __webpack_public_path__ + "static/media/orange-door.c117be1f.png";